<script setup>
import { defineProps, defineEmits } from 'vue';

const emit = defineEmits(['confirm', 'cancel']);
const onConfirm = () => emit('confirm');
const onCancel = () => emit('cancel');
</script>

<template>
    <div class="modal fade confirmation-modal-box" id="deleteConfirmationModal" aria-modal="true" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="swal2-icon swal2-question">
                        <div class="swal2-icon-content">!</div>
                    </div>
                    <div class="conformation-msg">
                        <h2>Confirmation</h2>
                        <p>Are you sure?</p>
                    </div>
                    <div class="btn-group-row">
                        <button type="button" class="btn btn-danger" @click="onCancel">Cancel</button>
                        <button type="button" class="btn btn-primary" @click="onConfirm">Delete</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
#confirmationModal {
    z-index: 9999 !important;
}
</style>